import React, { useState } from "react";

import Grid from "@mui/material/Grid";
import Paginator from "./Paginator";

import TableDisplay from "./TableDisplay";

import { rawData } from "../../../rawData";
import config from "../../../config.json";

import { useSelector } from "react-redux";

const { dataSettings, cartTableSettings } = config;
const { columns } = cartTableSettings;
const { uid, display } = dataSettings;

function CartTableView() {
  const idsOfItemsInCart = useSelector((state) => state.idsOfItemsInCart);
  const cartData = rawData.filter((d) => idsOfItemsInCart.includes(d[uid]));

  const [pageNumber, setPageNumber] = useState(1);

  const numResultsPerPage = 5;

  // Derive paginator props
  const startIndex = (pageNumber - 1) * numResultsPerPage + 1;
  const endIndex = Math.min(pageNumber * numResultsPerPage, cartData.length);
  const numPages = Math.ceil(cartData.length / numResultsPerPage);
  const numItems = cartData.length;

  // Derive table props
  const resultsInView = cartData.slice(startIndex - 1, endIndex);

  return (
    <Grid container sx={{ color: "text.primary" }}>
      <TableDisplay
        cartData={resultsInView}
        columns={columns}
        display={display}
        uid={uid}
      ></TableDisplay>
      <Paginator
        pageNumber={pageNumber}
        numPages={numPages}
        startIndex={startIndex}
        endIndex={endIndex}
        numItems={numItems}
        setPageNumber={setPageNumber}
      ></Paginator>
    </Grid>
  );
}

export default CartTableView;
